import esMessages from "./es.json"
import enMessages from "./en.json"

export default {
  es: esMessages,
  en: enMessages
}
